import React from 'react'
import { Row,Col } from 'antd'
import { images } from '../Assets/ImagesExports/ImageExport'
import { useNavigate } from 'react-router-dom'

const PageHeader = ({title,btnName,link}) => {

  const navigate = useNavigate()
  return (
    <div>
       <Row className='dashboad_page_header'>
          <Col className='dashboad_page_header_left'>
            <img src={images.apple_key_icon} className='instructor_page_header_icon'/>
           <h2 className='light_grey'>{title}</h2>
          </Col>
          <Col>
            {
              btnName &&
              <button className='dasboard_pageheader_btn'
               onClick={() => link ? navigate(link) : null}
              >
                + {btnName}
              </button>
            }
          </Col>
       </Row>
    </div>
  )
}

export default PageHeader
